import { useState } from "react";
// Common Components
import { CommonTableUI } from "src/Tables/TableTemplate/common";
import TableTemplate from "src/Tables/TableTemplate/tableTemplate";
import { Additional } from "./Additional";
// Local Components
import { GoldPositionAdditional } from "./GoldPositionAdditional";
import Charts from "./Charts";
import Portfolio from "./Portfolio";
// Requests
import {
  getExecutionStatusTable,
  getGoldPositionTable,
  getTriggeredPositionsTable,
} from "src/Requests/goldArbitrage";
// Types
import {
  ExecutionStatusSearchParams,
  ExecutionStatusTableReport,
  GoldPositionSearchParams,
  GoldPositionTableReport,
  TriggeredPositionsSearchParams,
  TriggeredPositionsTableReport,
} from "src/Interfaces/goldArbitrage";

const ExecutionStatus = () => {
  const [goldPositionSearchParams, setGoldPositionSearchParams] =
    useState<GoldPositionSearchParams>({} as GoldPositionSearchParams);
  const [selectedExecutionStatusRow, setSelectedExecutionStatusRow] =
    useState<ExecutionStatusTableReport | null>(null);

  return (
    <div className="flex flex-col justify-start items-start gap-3 w-full">
      <div className="flex flex-row justify-start items-start gap-3 w-full">
        <div className="flex flex-col gap-3 w-max max-w-full shrink-0">
          <TableTemplate<ExecutionStatusSearchParams, ExecutionStatusTableReport>
            TableUI={({ reports, onAction }) => (
              <CommonTableUI
                reports={reports}
                onAction={onAction}
                activeRowId={selectedExecutionStatusRow?.id}
                tableBoxClassName="!max-h-[350px] order-table"
                onTableRowClick={(row) => {
                  setSelectedExecutionStatusRow(row);
                  setGoldPositionSearchParams({
                    accountId: row.accountId,
                  });
                }}
              />
            )}
            getDataTable={getExecutionStatusTable}
            searchParameters={{} as ExecutionStatusSearchParams}
            tableWrapperClassname="!mx-0 !w-full"
            refreshTableTime={20000}
          />
          <Portfolio taskId={selectedExecutionStatusRow?.id} />
        </div>

        <TableTemplate<GoldPositionSearchParams, GoldPositionTableReport>
          TableUI={({ reports, onAction }) => (
            <CommonTableUI
              reports={reports}
              onAction={onAction}
              AdditionalBody={GoldPositionAdditional}
              tableBoxClassName="max-h-[350px] order-table"
            />
          )}
          getDataTable={getGoldPositionTable}
          searchParameters={goldPositionSearchParams}
          tableWrapperClassname="!mx-0 !w-full flex-1 min-w-0"
          refreshTableTime={20000}
        />
      </div>

      <Charts accountId={selectedExecutionStatusRow?.accountId} />

      <TableTemplate<
        TriggeredPositionsSearchParams,
        TriggeredPositionsTableReport
      >
        TableUI={({ reports, onAction }) => (
          <CommonTableUI
            reports={reports}
            onAction={onAction}
            AdditionalBody={Additional}
            tableBoxClassName="max-h-[350px] order-table"
          />
        )}
        getDataTable={getTriggeredPositionsTable}
        searchParameters={{} as TriggeredPositionsSearchParams}
        refreshTableTime={15000}
      />
    </div>
  );
};

export default ExecutionStatus;
